import { render } from "./NewLeaveLoader.vue?vue&type=template&id=0a883a82"
import script from "./NewLeaveLoader.vue?vue&type=script&lang=js"
export * from "./NewLeaveLoader.vue?vue&type=script&lang=js"

import "./NewLeaveLoader.vue?vue&type=style&index=0&id=0a883a82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__